/** @module Enums */ /** typedoc */
/**
 * This Enum purpose is to regroup ReleasePayoutStatus in a few categories.
 *
 * https://github.com/Mixgenius/LANDR.Distribution/blob/master/src/LANDR.Distribution/Services/Payouts/PayoutStatusEnum.cs
 */
var ReleasePayoutGlobalStatusEnum;
(function (ReleasePayoutGlobalStatusEnum) {
    ReleasePayoutGlobalStatusEnum["Completed"] = "Completed";
    ReleasePayoutGlobalStatusEnum["Pending"] = "Pending";
    ReleasePayoutGlobalStatusEnum["Error"] = "Error";
})(ReleasePayoutGlobalStatusEnum || (ReleasePayoutGlobalStatusEnum = {}));

export { ReleasePayoutGlobalStatusEnum };
